/**
 * Reads a browser cookie and returns the stored value.
 *
 * @param  {string} name Name of cookie.
 * @return  {string|boolean} Returns the value of the cookie. True/False will be treated as booleans, but other types return strings.
 */

export default function(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
